import {Grid, Box, useTheme, useMediaQuery} from "@mui/material";
import TotalizerAlarms from "../TotalizerAlarms/TotalizerAlarms";
import AlarmPage from "../Alarms/AlarmPage";
import { useState } from "react";
import { ADataGridFilter, ASectionTitle } from "@atiautomacao/ati-ui-library";
import { LoadingButton } from "@mui/lab";
import SideBar from "../Alarms/Components/sideBarFilterAlarms";
import {ChipFilterAlarms} from "../Alarms/Components/ChipFilterAlarms";
import {Storage} from "../../../Utils/StorageUtils";
import { ALARM_ADVANCED_FILTERS_KEY } from "../Alarms/Components/ChipFilterAlarms/types";

export type TotalizerType =  "alarms_sound" | "not_acknowledged" | "power_station_no_communication"  | "equipment_no_communication" | "equipments_alarmed" | "active" | "active_critical" | "none";

const ALARM_FILTERS_COUNT_KEY = 'alarm_filters_count';
const TOTALIZER_ALARM_FILTER_KEY = 'totalizer_alarm_filter';

const getInitialAdvancedFilters = (): ADataGridFilter[] => {
    const stored = Storage.local.get(ALARM_ADVANCED_FILTERS_KEY, null);
    if (stored && Array.isArray(stored)) {
        return stored;
    }
    const storedTotalizer = localStorage.getItem(TOTALIZER_ALARM_FILTER_KEY) as TotalizerType ?? "none";
    if (storedTotalizer !== "none") {
        return [{ name: 'totalizerType', condition: 'equals', value: storedTotalizer, sort: 'none' }];
    }
    return [];
};

const getInitialFiltersCount = (): number => {
    const stored = Number(Storage.local.get(ALARM_FILTERS_COUNT_KEY, 0));
    return Number.isFinite(stored) && stored >= 0 ? stored : 0;
};

export default function DashboardOverviewAlarmsPage() {
    const theme = useTheme();
    const isXl = useMediaQuery(theme.breakpoints.up('xl'));

    const [sideBarOpen, setSideBarOpen] = useState(false);
    const [totalizerFilter, setTotalizerFilter] = useState<TotalizerType>(localStorage.getItem(TOTALIZER_ALARM_FILTER_KEY) as TotalizerType ?? "none");
    const [advancedFilters, setAdvancedFilters] = useState<ADataGridFilter[]>(getInitialAdvancedFilters);
    const [isClearFilters, setIsClearFilters] = useState<boolean>(false);
    const [appliedFiltersCount, setAppliedFiltersCount] = useState<number>(getInitialFiltersCount);

    const mergeFiltersWithTotalizer = (sidebarFilters: ADataGridFilter[], totalizer: TotalizerType): ADataGridFilter[] => {
        const baseFilters = sidebarFilters.filter(f => f.name !== 'totalizerType');

        if (totalizer !== 'none') {
            baseFilters.push({
                name: 'totalizerType',
                condition: 'equals',
                value: totalizer,
                sort: 'none'
            });
        }

        return baseFilters;
    };

    const handleTotalizerChange = (totalizer: TotalizerType) => {
        localStorage.setItem(TOTALIZER_ALARM_FILTER_KEY, totalizer);
        setTotalizerFilter(totalizer);
        setAdvancedFilters(prev => {
            const merged = mergeFiltersWithTotalizer(prev, totalizer);
            Storage.local.set(ALARM_ADVANCED_FILTERS_KEY, merged);
            return merged;
        });
        setIsClearFilters(false);
    };

    const handleApplySideBarFilters = (sidebarFilters: ADataGridFilter[], filtersCount: number) => {
        const merged = mergeFiltersWithTotalizer(sidebarFilters, totalizerFilter);
        setAdvancedFilters(merged);
        Storage.local.set(ALARM_ADVANCED_FILTERS_KEY, merged);
        setSideBarOpen(false);
        setAppliedFiltersCount(filtersCount);
        Storage.local.set(ALARM_FILTERS_COUNT_KEY, filtersCount);
        setIsClearFilters(false);
    };

    const handleClearFilters = (cleared: boolean) => {
        if (cleared) {
            setAdvancedFilters([]);
            Storage.local.remove(ALARM_ADVANCED_FILTERS_KEY);
            setAppliedFiltersCount(0);
            Storage.local.remove(ALARM_FILTERS_COUNT_KEY);
            setIsClearFilters(true);
            Storage.local.remove(TOTALIZER_ALARM_FILTER_KEY);
        }
    };
        
    return (
            <Grid container paddingLeft={'24px'} paddingRight={'24px'} paddingBottom={'24px'}>
                <Grid item xs={12} paddingTop={0}>
                    <ASectionTitle
                        titleLabel={"Alarmes"}
                        styleContainer={{padding: '0px'}}
                        styleContainerTitle={{padding: '0px'}}
                        contentChildrenStyle={{display: isXl ? 'none' : 'flex'}}
                        contentChildren={                            
                            <LoadingButton
                                size="small"
                                loading={false}
                                startIcon={
                                    <Box 
                                        sx={{
                                            color: theme.palette.primary.main,
                                            backgroundColor: '#fff',
                                            fontSize: '0.75rem !important',
                                            width: '24px',
                                            height: '24px',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center', 
                                        }}
                                    >
                                        {appliedFiltersCount}
                                    </Box>
                                }
                                variant="contained"
                                onClick={() => setSideBarOpen(true)}
                            >
                                Filtros Avançados
                            </LoadingButton>
                        }
                    />
                </Grid>
                <Grid item xs={12} paddingTop={'16px'}>
                    <TotalizerAlarms onClickTotalizer={handleTotalizerChange} clearFilters={isClearFilters} 
                     />
                </Grid>
                <Grid item xs={12} paddingTop={'4px'} sx={{display: isXl ? 'block' : 'none'}}>
                    <ChipFilterAlarms onApplyFilters={handleApplySideBarFilters} hasClearFilters={isClearFilters} />
                </Grid>
                <Grid item xs={12} paddingTop={'24px'}>
                    <AlarmPage advancedFilters={advancedFilters} 
                    hasClearFilters={handleClearFilters} />
                </Grid>
                <SideBar
                    open={sideBarOpen}
                    onClose={() => setSideBarOpen(false)}
                    onApplyFilters={handleApplySideBarFilters}
                    hasClearFilters={isClearFilters}
                />
            </Grid>
    )
}
